import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '25px',
    marginBottom: '4px',
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '4px',
    paddingBottom: '20px',
  },
  searchBox: {
    width: '100%',
    maxWidth: 1000,
  },
}));

export default useStyles;
